import moment from 'moment';

export default class UseInfoReport {
  ready() {
    $(document).ready(function() {
      const dateFormat = "yy/mm/dd";

      $('#date_from').datepicker({
        dateFormat,
        onSelect: function (date) {
          let dateTo = $('#date_to').val();
          let dateNextMonth = moment(date).add(1, 'months');
          let selectDate = moment(new Date(dateTo)).diff(new Date(date), 'days', true);
          let nextMonth = moment(new Date(dateNextMonth)).diff(new Date(date), 'days', true);

          if (selectDate > nextMonth || selectDate < 0) {
            $('#date_to').val(dateNextMonth.format('YYYY/MM/DD'));
          }
        }
      });

      $('#date_to').datepicker({
        dateFormat,
        onSelect: function (date) {
          let dateFrom = $('#date_from').val();
          let dateNextMonth = moment(dateFrom).add(1, 'months');
          let selectDate = moment(new Date(date)).diff(new Date(dateFrom), 'days', true);
          let nextMonth = moment(new Date(dateNextMonth)).diff(new Date(dateFrom), 'days', true);

          if (selectDate > nextMonth || selectDate < 0) {
            $('#date_from').val(moment(date).add(-1, 'months').format('YYYY/MM/DD'));
          }
        }
      });
    });

    $(document).on('change', '.js-select-date', function() {
      let targetName = event.target.name;
      let dateFormat = 'YYYY/MM/DD';
      let date = moment(new Date());

      if (targetName === 'is_manual') {
        $('input[name="date"]').prop('checked', false);
        $('#date_from').removeAttr('disabled');
        $('#date_to').removeAttr('disabled');
        $('#date_from').val(date.startOf('month').format(dateFormat));
        $('#date_to').val(date.endOf('month').format(dateFormat));
      } else {
        if (targetName === 'date') {
          $('input[name="is_manual"]').prop('checked', false);
          $('#date_from').attr('disabled', true);
          $('#date_to').attr('disabled', true);
          if (event.target.id == 'date-1') {
            date = date.add(-1, 'months');
          }
          $('#date_from').val(date.startOf('month').format(dateFormat));
          $('#date_to').val(date.endOf('month').format(dateFormat));
        }
      }
    });
  }
}
